<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../../app.config";

/**
 * Form elements component
 */
export default {
  page: {
    title: "Programa de promoción y prevención en salud",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "",
      items: [
        {
          text: "Base de conocimiento",
          href: "/forms/general",
        },

        {
          text: "Programa de promoción y prevención en salud",
          active: true,
        },
      ],
      text: `
         ... `,
      text2: `Labore sit culpa commodo elit adipisicing sit aliquip elit proident voluptate minim mollit nostrud aute reprehenderit do. Mollit excepteur eu Lorem ipsum anim commodo sint labore Lorem in exercitation velit incididunt. Occaecat consectetur nisi in occaecat proident minim enim sunt reprehenderit exercitation cupidatat et do officia. Aliquip consequat ad labore labore mollit ut amet. Sit pariatur tempor proident in veniam culpa aliqua excepteur elit magna fugiat eiusmod amet officia.`,
    };
  },
  methods: {
    /**
     * Vuelve a la página anterior real. Esta vista se abre tanto desde la base
     * de conocimiento como desde su ítem, así que no se puede fijar el destino.
     * Si no hay historial (entrada directa o refresh) cae a la base de conocimiento.
     */
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push("/forms/general");
      }
    },

    /**
     * Scrollspy
     */
    scrollIntoView(evt) {
      evt.preventDefault();
      const href = evt.target.getAttribute("href");
      const el = href ? document.querySelector(href) : null;
      if (el) {
        this.$refs.content.scrollTop = el.offsetTop;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <h4 class="header-title">Programa de promoción y prevención en salud</h4>
              </div>

              <div class="col-6 text-right">
                <button type="button" class="btn btn-secondary m-l-5 ml-1" id="tooltip" @click="goBack">
                  <i class="fas fa-arrow-left"></i>
                </button>
                <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
              </div>
            </div>
            <br />
            <b-row>
              <b-col cols="4">
                <b-list-group v-b-scrollspy:listgroup-ex>
                  <b-list-group-item href="#list-item-1">
                    ¿Qué son los programas de promoción y prevención en salud?
                  </b-list-group-item>
                  <b-list-group-item href="#list-item-2">
                    ¿Cuáles son las actividades que se pueden desarrollar en las
                    empresas?
                  </b-list-group-item>
                  <b-list-group-item href="#list-item-3"
                    >1. Evaluaciones médicas ocupacionales</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-4"
                    >2. Diagnóstico de las condiciones de salud</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-5">
                    3. Variables sociodemográficas de la población  
                  </b-list-group-item>
                  <b-list-group-item href="#list-item-6"
                    >4. Investigación de enfermedades laborales</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-7"
                    >5. Programas de vigilancia epidemiológica</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-8">
                   5.1. Metodología de intervención  
                  </b-list-group-item>
                  <b-list-group-item href="#list-item-9"
                    >5.2. Fases de los programas de vigilancia epidemiológica</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-10"
                    >6. Reincorporación o rehabilitación</b-list-group-item
                  >
                  
              
                  <!--  <b-list-group-item href="#list-item-5"
                    >!.1.2</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-6"
                    >1.1.3</b-list-group-item
                  >-->
                </b-list-group>
              </b-col>

              <b-col cols="8">
                <div
                  id="listgroup-ex"
                  style="position: relative; overflow-y: auto; height: 500px"
                >
                  <h4 id="list-item-1">
                    ¿Qué son los programas de promoción y prevención en salud?
                  </h4>
                  <p>
                    Los programas de promoción y prevención se realizan para
                    prevenir posibles riesgos asociados al desarrollo de las
                    actividades laborales de una empresa. Conlleva un programa
                    de seguridad y salud en el trabajo, en el que se promueve el
                    bienestar laboral, así como la prevención y control de la
                    salud del trabajador, con el fin de mitigar los factores que
                    representan un riesgo para su salud y su integridad física;
                    y abordar de manera adecuada las enfermedades y accidentes
                    derivados de la actividad ejecutada por el trabajador
                    afectado.
                  </p>
                  <h4 id="list-item-2">
                    ¿Cuáles son las actividades que se pueden desarrollar en las
                    empresas?
                  </h4>
                  <p>
                    Para trabajar en pro del cuidado de la salud y del bienestar
                    de los colaboradores, se pueden realizar una gran variedad
                    de actividades que traerán consigo varios beneficios. A
                    continuación, compartimos algunas de esas actividades:
                  </p>
                  <ul>
                    <li>Estadísticas de morbimortalidad.</li>
                    <li>
                      Identificar enfermedades con mayor incidencia para su
                      prevención y control, eliminar las causas y reducir el
                      ausentismo.
                    </li>
                    <li>
                      Estudios de ausentismo para orientar acciones tendientes a
                      reducir el tiempo perdido.
                    </li>
                    <li>
                      Programas de Vigilancia Epidemiológica para enfermedades
                      de origen laboral, enfermedad relacionada con el trabajo y
                      enfermedades comunes prevalentes.
                    </li>
                    <li>
                      Actividades de prevención de enfermedades laborales,
                      accidentes laborales y educación en salud a los
                      trabajadores.
                    </li>
                    <li>
                      Prestar asesoría en aspectos médicos laborales, tanto en
                      forma individual como colectiva.
                    </li>
                    <li>
                      Exámenes médicos en prevención primaria: Ingreso,
                      reubicación, post incapacidad.
                    </li>
                    <li>
                      Exámenes médicos en prevención secundaria: Periódicos,
                      egresos y otros.
                    </li>
                  </ul>
                  <h4 id="list-item-3">1. Evaluaciones médicas ocupacionales</h4>
                  <p>
                    Según le resolución 2569 de 1999, y la resolución 2346 del
                    2007, toda empresa debe definir el procedimiento para la
                    realización de las evaluaciones médicas, los exámenes
                    clínicos y paraclínicos necesarios para cada trabajador, así
                    como los criterios de aptitud y condiciones de salud. Las
                    evaluaciones médicas ocupacionales son:
                  </p>
                  <ul>
                    <li>Estadísticas de morbimortalidad.</li>
                    <li>Evaluaciones médicas de ingreso o pre ocupacionales</li>
                    <li>Evaluaciones Médicas Periódicas</li>
                    <li>Evaluaciones Médicas por cambios de ocupación</li>
                    <li>Evaluaciones Médicas de Retiro</li>
                    <li>Evaluaciones Médicas post incapacidad</li>
                  </ul>
                  <h4 id="list-item-4">
                    2. Diagnóstico de las condiciones de salud
                  </h4>
                  <p>
                    La empresa realizará el Diagnóstico de Salud de los
                    trabajadores, con el fin de establecer el perfil general de
                    la población trabajadora, en cuanto a presencia de
                    enfermedades en sus trabajadores, se realizará un análisis
                    demográfico teniendo en cuenta el tipo de contratación
                    laboral y otras características. El diagnóstico de las
                    condiciones de salud cuenta con la información de variables
                    demográficas, ocupacionales y hallazgos de morbilidad a
                    partir los resultados de las evaluaciones ocupacionales
                    periódicas realizadas a los trabajadores por el médico de
                    Seguridad y Salud en el Trabajo. Las IPS que realizan las
                    evaluaciones médicas ocupacionales deben entregar el
                    diagnóstico de las condiciones de salud con el consolidado
                    de la información de las personas evaluadas.
                    <br>
                    El diagnóstico de salud tiene la siguiente información: 
                  </p>

                  <ul>
                    <li>Información sociodemográfica de la población trabajadora. </li>
                    <li>Información de antecedentes de exposición laboral a diferentes factores de riesgos ocupacionales. </li>
                    <li>Información de exposición laboral actual, según la manifestación de los trabajadores y los resultados objetivos analizados durante la evaluación médica. Tal información deberá estar diferenciada según áreas u oficios. </li>
                    <li>Sintomatología reportada por los trabajadores.  </li>
                    <li>Resultados generales de las pruebas clínicas o paraclínicas complementarias a los exámenes físicos realizados.</li>
                    <li>Diagnósticos encontrados en la población trabajadora.   </li>
                    <li>Análisis y conclusiones de la evaluación. </li>
                    <li>Recomendaciones.</li>
                  </ul>
                  <h4 id="list-item-5">
                    3. Variables sociodemográficas de la población  
                  </h4>
                  <p>
                    Es indispensable conocer las características de la población trabajadora toda vez que esto nos permite conocer las diferentes variables sociodemográficas, en la creación de los colaboradores se incluyen todas estas variables y en el ítem 3.1.1 podrá encontrar el consolidado para descarga.  
                    <br>
                    <h5>Plan de análisis y priorización  </h5>
                    <br> 

                    Del análisis de los hallazgos se determinan las necesidades para ser abordadas en el plan de intervenciones del Sistema de Gestión en Seguridad y Salud en el Trabajo. Dentro del seguimiento que se realiza a los trabajadores por parte de Seguridad y Salud en el Trabajo tenemos:  
                    <br>
                  </p>
<ul>
  <li>Hacer seguimiento y remitir a la EPS a los trabajadores con enfermedad común, con la asistencia periódica a consulta médica y la toma de laboratorios correspondientes.  
 </li>
<li>
Seguimiento al origen de enfermedades laborales para hacer intervención en el trabajador y en el puesto de trabajo.  
 </li>
<li>
Asistir a las actividades programadas por el Sistema de Gestión en SST cuando sea citado por este.  
</li>
<li>
Estar en continua comunicación con la dirección del Sistema de Gestión en SST, con el fin de informar los hallazgos y necesidades de los trabajadores de la entidad para que con ello sean programadas las actividades adecuadas. </li>
</ul>
                  <h4 id="list-item-6">
                    4. Investigación de enfermedades laborales
                  </h4>
                  <p>
                    Las empresas tienen como obligación legal investigar las enfermedades laborales y los daños a la salud que puedan estar producidos con ocasión o como consecuencia del trabajo (patologías no traumáticas causadas por el trabajo). Esta investigación debe adelantarse acorde con lo establecido en el Decreto número 1530 de 1996, la Resolución número 1401 de 2007 y el Decreto 1072 de 2015. El resultado de esta investigación, debe permitir entre otras, las siguientes acciones:  
                  </p>
<ul>
  <li>Identificar y documentar las deficiencias del Sistema de Gestión de la Seguridad y Salud en el Trabajo (SG-SST); lo cual debe ser el soporte para la implementación de las acciones preventivas, correctivas y de mejora necesarias.</li>
  <li>Informar de sus resultados a los trabajadores directamente relacionados con sus causas o con sus controles, para que participen activamente en el desarrollo de las acciones preventivas, correctivas y de mejora. </li>
  <li>Informar a la alta dirección sobre el ausentismo laboral por incidentes, accidentes de trabajo y enfermedades laborales. </li>
  <li>Alimentar el proceso de revisión que haga la alta dirección de la gestión en seguridad y salud en el trabajo y que se consideren también en las acciones de mejora continua. (Decreto 1072 de 2015 Art. 2.2.4.6.32). </li>
</ul>
                  <h4 id="list-item-7">
                    5. Programas de vigilancia epidemiológica
                  </h4>
                  <p>
                    La vigilancia epidemiológica es “información para la acción”, por lo tanto, las empresas deben realizar el registro y análisis de la información de variables sociodemográficas, encuestas de morbilidad, estadísticas de ausentismo, diagnóstico de salud de los trabajadores, y factores de riesgo prioritarios, con el fin de plantear acciones de prevención y control de las enfermedades laborales, comunes o agravadas por el trabajo o por accidentes. Estos programas se realizan de acuerdo a las enfermedades de origen laboral que se presenten con mayor frecuencia en la población trabajadora de acuerdo con los informes diagnósticos realizados con anterioridad del cual se establecerán las prioridades en cuanto a las patologías halladas, teniendo en cuenta el panorama general de factores de riesgo, con el objeto de hacer seguimiento de las patologías laborales y establecer medidas de control, bien sea en la fuente o en el individuo. 
                    <br>
                    Los Programas de Vigilancia Epidemiológica tienen como objetivo: 
                  </p>
                    <ul>
                      <li>Prevenir la ocurrencia de nuevos casos.  
</li>
<li>
Disminuir la progresión de los existentes.  
</li>
<li>
Tener en cuenta medidas de prevención y control en la fuente, medio y en el individuo.  </li>
<li>Evaluar y retroalimentar el proceso periódicamente. </li>
<li>Implementar medidas de control, de acuerdo con las condiciones actuales del trabajo. </li>
<li>Evaluar en términos de índices de gestión, porcentaje de cumplimiento, análisis de tendencias y planes de acción.  </li>
<li>Disponer de protocolos de vigilancia epidemiológica ocupacional.  </li>
                    </ul>
                  <h4 id="list-item-8">
                    5.1. Metodología de intervención   
                  </h4>
                  <p>
                    La metodología para intervenir en los sistemas de vigilancia epidemiológica está dada por:  
                    <br>
                  </p>
                    <ul>
                      <li>Caracterización del evento a vigilar  
 </li>
<li>
Identificación del riesgo y nivel de control  
</li>
<li>
Diagnóstico de Salud y Gestión de Salud  
 </li>
<li>
Priorización del evento a vigilar  </li>
                    </ul>
<p>

  <h5>Grupo de exposición similar:</h5> De acuerdo con los informes se realizarán grupos de exposición similar que corresponde al grupo de trabajadores que, por su cargo u oficio, tiene la misma probabilidad de enfermar o lesionarse por razón de su exposición a condiciones de riesgo similar, presentes en el ambiente de trabajo.  
</p>
                  <h4 id="list-item-9">
                    5.2. Fases de los programas de vigilancia epidemiológica
                  </h4>
                  <p>
                    <h5>Fase diagnóstica:</h5> Determinación del Riesgo.
                  </p> 
                    <ul>
                      <li>Reconocimiento de factores de riesgo: Identificación de problemas, identificación de medidas concretas de mejora e identificación de problemas a estudiar con más detalle). 
</li>
<li>
Cuantificación del riesgo: Se realizarán encuestas de morbilidad sentida y evaluaciones a los trabajadores, con el fin de determinar las condiciones de salud, además de los riesgos a los que está expuesto.  
</li>
<li>
Evaluación médica individual: se realizarán los exámenes periódicos con énfasis en la el sistema identificado  </li>
                    </ul> 
                    <p>
                   <h5>Fase de control o intervención:</h5>   

Administrativas: Relacionadas con la organización del trabajo.  
<br>
En la fuente: Relacionadas con equipos, máquinas, herramientas.  
<br>
Con los trabajadores: Desarrollo de cualidades físicas, cognitivas, de adaptación al trabajo, y educativas. 
                  </p>
                  <h4 id="list-item-10">
                    6. Reincorporación o rehabilitación
                  </h4>
                  <p>
                  El proceso de rehabilitación del paciente y la reincorporación de los trabajadores a sus actividades laborales, posterior a un evento de salud como puede ser una enfermedad de origen laboral o un accidente de trabajo que generan incapacidades que presentan deterioro en la condición del paciente , generando una discapacidad de base y requieren una adecuación de sus condiciones laborales, inicia con la evaluación por parte de un médico laboral, ya sea de la ARL  o de la empresa, quienes se encargan de rehabilitar al paciente con unas recomendaciones y si es necesario indican la reubicación del paciente, estas recomendaciones deben ser validadas e implementadas por la empresa. 
                  </p>
       
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
